import baseMetaObject from "core/services/metaStoreService/metaObjects/base-meta-object";

var module = {};

module.Model = baseMetaObject.Model.extend({
    defaults: {
        type: "AIAGENT",
        status: null,
        applications: Object
    }
});

module.Collection = baseMetaObject.Collection.extend({
    model: module.Model
});

export default module;
